<form [formGroup]="form" (ngSubmit)="onSave()">
  <div p-dialog-content>
    <div>
      <p-divider align="left">
        <div class="inline-flex align-items-center">
          <b>Integration settings</b>
        </div>
      </p-divider>
      <div class="grid">
        <div class="col">
          <label class="block font-bold mb-2" for="url">Name</label>
          <input inputId="url"
                 type="text"
                 pInputText
                 class="w-full p-inputtext"
                 formControlName="name" />
        </div>
        <div class="col">
          <label class="block font-bold mb-2" for="url">Type</label>
          <input inputId="url"
                 type="text"
                 pInputText
                 class="w-full p-inputtext"
                 formControlName="type" />
        </div>
      </div>
      <div class="grid">
        <div class="col">
          <label class="block font-bold mb-2" for="auth">Integration Method</label>

          <div class="flex gap-3">
            <div *ngFor="let item of methodOptions"
                 class="flex align-items-center justify-content-center">
              <p-radioButton [value]="item.value"
                             formControlName="method"
                             [inputId]="item.value"></p-radioButton>
              <label [for]="item.value" class="ml-2 mb-0">
                {{
                item.name
                }}
              </label>
            </div>
          </div>
        </div>

        <div class="col" *ngIf="form.get('method').value">
          <label class="block font-bold mb-2" for="category">Integration Category</label>

          <div class="flex gap-3" *ngIf="form.get('method').value == 'GET' || form.get('method').value == 'AWSConfig' || form.get('method').value == 'AWSCloudTrail' || form.get('method').value == 'S3Download' || form.get('method').value == 'Generic'">
            <div *ngFor="let item of getCategoryOptions"
                 class="flex align-items-center">
              <p-radioButton [value]="item.value"
                             formControlName="category"
                             [inputId]="item.value"></p-radioButton>
              <label [for]="item.value" class="ml-2 mb-0">
                {{
                item.name
                }}
              </label>
            </div>
          </div>
          <div class="flex gap-3"
               *ngIf="
              form.get('method').value == 'POST' ||
              form.get('method').value == 'FILE' ||
              form.get('method').value == 'S3Upload'
            ">
            <div *ngFor="let item of postOrFileCategoryOptions"
                 class="flex align-items-center">
              <p-radioButton [value]="item.value"
                             formControlName="category"
                             [inputId]="item.value"></p-radioButton>
              <label [for]="item.value" class="ml-2 mb-0">
                {{
                item.name
                }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="p-2">
        <ng-container [ngSwitch]="form.get('category').value">
          <integration-apps-oscal-catalog *ngSwitchCase="'OSCAL_Catalog'"
                                          [settings]="integration.settings"
                                          [settingsForm]="form.get('settings')"></integration-apps-oscal-catalog>
          <integration-apps-oscal-implementation *ngSwitchCase="'OSCAL_Implementation'"
                                                 [projects]="projects"
                                                 [settings]="integration.settings"
                                                 [settingsForm]="form.get('settings')"></integration-apps-oscal-implementation>
          <integration-apps-oscal-poam *ngSwitchCase="'OSCAL_POAM'"
                                       [projects]="projects"
                                       [settings]="integration.settings"
                                       [settingsForm]="form.get('settings')"></integration-apps-oscal-poam>
          <integration-apps-oscal-profile *ngSwitchCase="'OSCAL_Profile'"
                                          [projects]="projects"
                                          [settings]="integration.settings"
                                          [settingsForm]="form.get('settings')"></integration-apps-oscal-profile>
          <integration-apps-oscal-profile-category *ngSwitchCase="'OSCAL_Category'"
                                                   [projects]="projects"
                                                   [settings]="integration.settings"
                                                   [settingsForm]="form.get('settings')"></integration-apps-oscal-profile-category>
          <integration-apps-oscal-sap *ngSwitchCase="'OSCAL_SAP'"
                                      [sapProfiles]="sapProfiles"
                                      [settings]="integration.settings"
                                      [settingsForm]="form.get('settings')"></integration-apps-oscal-sap>
          <integration-apps-oscal-sar *ngSwitchCase="'OSCAL_SAR'"
                                      [sapProfiles]="sapProfiles"
                                      [sarProfiles]="sarProfiles"
                                      [settings]="integration.settings"
                                      [settingsForm]="form.get('settings')"></integration-apps-oscal-sar>
          <integration-apps-poam *ngSwitchCase="'POAM'"
                                 [settings]="integration.settings"
                                 [settingsForm]="form.get('settings')"></integration-apps-poam>
          <integration-apps-evidence *ngSwitchCase="'Evidence'"
                                     [settings]="integration.settings"
                                     [settingsForm]="form.get('settings')"></integration-apps-evidence>
        </ng-container>
      </div>
    </div>

    <div *ngIf="form.get('method').value == 'AWSConfig'">
      <p-divider align="left">
        <div class="inline-flex align-items-center">
          <b>Connection settings</b>
        </div>
      </p-divider>
      <integration-aws-config [settings]="integration.connectionSettings"
                              [settingsForm]="form.get('connectionSettings')" />
    </div>

    <div *ngIf="form.get('method').value == 'S3Download' || form.get('method').value == 'S3Upload'">
      <p-divider align="left">
        <div class="inline-flex align-items-center">
          <b>Connection settings</b>
        </div>
      </p-divider>
      <integration-s3-config [settings]="integration.connectionSettings"
                             [settingsForm]="form.get('connectionSettings')" />
    </div>

    <div *ngIf="form.get('method').value == 'AWSCloudTrail'">
      <p-divider align="left">
        <div class="inline-flex align-items-center">
          <b>Connection settings</b>
        </div>
      </p-divider>
      <integration-aws-cloudtrail [settings]="integration.connectionSettings"
                                  [settingsForm]="form.get('connectionSettings')" />
    </div>
    <div *ngIf="form.get('method').value == 'Generic'">
      <p-divider align="left">
        <div class="inline-flex align-items-center">
          <b>Connection settings</b>
        </div>
      </p-divider>
      <integration-generic [settings]="integration.connectionSettings"
                           [settingsForm]="form.get('connectionSettings')"/>
    </div>
    <div *ngIf="
        form.get('method').value === 'GET' ||
        form.get('method').value === 'POST'
      ">
      <p-divider align="left">
        <div class="inline-flex align-items-center">
          <b>Connection settings</b>
        </div>
      </p-divider>
      <div class="grid">
        <div class="col">
          <label class="block font-bold mb-2" for="url">URL</label>
          <input inputId="url"
                 type="text"
                 pInputText
                 class="w-full p-inputtext"
                 formControlName="url" />
        </div>
      </div>

      <div class="grid" formGroupName="authDetails">
        <div class="col">
          <label class="block font-bold mb-2" for="auth">Authorization</label>

          <div class="flex gap-3">
            <div *ngFor="let item of authOptions"
                 class="flex align-items-center">
              <p-radioButton [inputId]="item.name"
                             [value]="item.value"
                             formControlName="type"></p-radioButton>
              <label [for]="item.name" class="ml-2 mb-0">{{ item.name }}</label>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="" *ngIf="form.get('authDetails.type').value === 'Token'">
            <label class="block font-bold mb-2" for="token">Token</label>
            <input inputId="token"
                   type="password"
                   formControlName="token"
                   pInputText
                   class="w-full p-inputtext" />
          </div>
          <div class=""
               *ngIf="form.get('authDetails.type').value === 'Password'">
            <div class="">
              <label class="block font-bold mb-2" for="username">Username</label>
              <input inputId="username"
                     formControlName="username"
                     type="text"
                     pInputText
                     class="w-full p-inputtext" />
            </div>
            <div class="">
              <label class="block font-bold mb-2" for="password">Password</label>
              <input inputId="password"
                     formControlName="password"
                     type="password"
                     pInputText
                     class="w-full p-inputtext" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="form.get('method').value !== 'GET' && form.get('method').value !== 'AWSConfig' && form.get('method').value !== 'AWSCloudTrail'">
      <p-divider align="left">
        <div class="inline-flex align-items-center">
          <b>Schedule settings</b>
        </div>
      </p-divider>
      <div class="px-2">
        <scheduler [scheduleForm]="form.get('schedule')"
                   [schedule]="integration.schedule"></scheduler>
      </div>
    </div>
  </div>

  <div class="p-dialog-footer flex gap-2 justify-content-end">
    <p-button type="submit" label="Save" outlined="true"></p-button>
    <p-button
      label="Cancel"
      outlined="true"
      severity="secondary"
      (click)="onClose()"
    ></p-button>
  </div>
</form>
